import '../../boolean-fields/descope-checkbox';
import { getComponentName } from '../../../helpers/componentHelpers';
import { GridSelectionColumnClass } from './GridSelectionColumnClass';

export const componentName = getComponentName('grid-selection-column');

customElements.define(componentName, GridSelectionColumnClass);
